<template>
  <confirmation-dialog :action="cancel" confirm-text="Прервать работу мастера" confirm-btn-variant="primary">
    <template #activator>
      <e-btn append-icon-src="closeSvg" :icon="!$vuetify.display.mdAndUp" variant="context" size="M"
        ><span v-if="$vuetify.display.mdAndUp">Закрыть</span>
      </e-btn>
    </template>
    <h3 class="mb-4">Прерывание работы Мастера Вариантов размещения.</h3>
    <div class="text-secondary">
      Все введенные в рамках работы Мастера данные будут утеряны без возможности восстановления.
    </div>
  </confirmation-dialog>
</template>

<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router';
import ConfirmationDialog from '@/core/components/modals/ConfirmationDialog.vue';
import { EBtn } from '@/core/components/ui';
import { RouteNames } from '@/core/plugins/router/routeNames';

import { useTariffsStore } from '@/parts/tariffs/store/tariffs';

const $router = useRouter();
const $route = useRoute();

const { cancelPVMEdit, clearPVMMaterData } = useTariffsStore();

const cancel = async () => {
  await cancelPVMEdit();

  await $router.replace({
    name: RouteNames.TariffSettings,
    params: {
      id: $route.params.id,
      t_id: $route.params.t_id,
    },
  });

  clearPVMMaterData();
};
</script>

<style scoped lang="scss"></style>
